export default {
  changes: {
    // Tipos de cambio
    typeNewEntry: "Nueva entrada",
    typePriceChange: "Cambio precio",
    typeReimbursementChange: "Financiación",
    typeExclusion: "Exclusión",
    typeDeduction: "Deducción",
    typeWarning: "Nota",
    typeMarketingStatus: "Comercialización",
    typeEuRegistration: "Registro europeo",
    typeExclusivity: "Exclusividad",
    colSource: "Fuente",
    exporting: "Exportando…",
    // Estados del registro europeo (EMA los publica en inglés)
    emaAuthorised: "Autorizado",
    emaApplicationWithdrawn: "Solicitud retirada",
    emaWithdrawn: "Retirado",
    emaRefused: "Rechazado",

    // Marcas de equipo
    star: "Destacar",
    unstar: "Quitar destacado",
    markReviewed: "Marcar como revisado",
    reviewedBy: "Revisado por {who}",
    theTeam: "el equipo",
    addTeamNote: "Añadir nota de equipo",
    noteFrom: "Nota de {who}: {note}",
    team: "equipo",
    notePlaceholder: "Nota visible para todo tu equipo…",
    lastEdit: "Última edición: {who}",
    close: "Cerrar",
    save: "Guardar",

    // Cabecera
    title: "Eventos detectados",
    subtitle: "Eventos de precios, financiación, autorizaciones y seguridad de tu portfolio y tu competencia.",
    regulatoryPrefix: "Los eventos regulatorios están en el ",
    regulatoryRadar: "Radar Regulatorio ↗",
    exportExcel: "Exportar Excel",
    exportCsv: "CSV",

    // Filtros activos
    clearFilter: "Quitar filtro",

    // Filtros
    searchPlaceholder: "Buscar producto, CN, P.Activo, laboratorio…",
    // Consolidación C-14 (§90 Fase 1C)
    consolidate: "Agrupar confirmaciones",
    consolidateHint: "Un mismo hecho publicado por varias fuentes se muestra una vez, con el número de fuentes que lo confirman",
    confirmedBy: "Confirmado por {n} fuentes: {sources}",
    originDoc: "Abrir el documento que originó este evento (BOE, CIPM, nota oficial…)",
    originDocShort: "documento",
    candidate: "Candidata",
    candidateConfirmed: "Candidata confirmada",
    candidateDiscarded: "Descartada",
    confirm: "Confirmar",
    discard: "Descartar",
    undo: "Deshacer",
    pendingCandidates: "Candidatas por revisar",
    discardedCandidates: "Candidatas descartadas",
    resolvedOn: "Resuelto el {date}",
    allTypes: "Todos los tipos",
    allSources: "Todas las fuentes",
    myLabAndCompetition: "Mi laboratorio + competencia",
    onlyOrg: "Solo {org}",
    onlyCompetition: "Solo competencia",
    allMarket: "Todo el mercado",
    allPriority: "Toda prioridad",
    priorityHigh: "Alta — tu portfolio",
    priorityMedium: "Media — tu competencia",
    priorityLow: "Baja — resto",
    allMarks: "Todas las marcas",
    starred: "Destacados",
    pendingReview: "Pendientes de revisar",
    reviewed: "Revisados",
    withNote: "Con nota",

    // Cabeceras de tabla
    colMarks: "Marcas",
    colDate: "Fecha",
    colPrio: "Prio.",
    colType: "Tipo",
    colProduct: "Producto",
    colActiveIngredient: "Principio Activo",
    colCurrentPrice: "Precio Actual",
    colPreviousPrice: "Precio Anterior",
    colDeduction: "Deducción",
    colCn: "CN",
    colLabel: "Titularidad",
    colLaboratory: "Laboratorio",

    // Estados
    loading: "Cargando…",
    noResults: "Sin resultados",
    viewProduct: "Ver ficha de {name}",
    viewAllChangesOf: "Ver todos los eventos de {lab}",

    // Etiquetas de cartera
    competitor: "Competidor",
    others: "Otros",

    // Paginación
    pageOf: "Pág. {page} de {total}",
    recordsFound: "{total} registros encontrados",
  },
};
